import React, { useEffect, useRef,useState } from 'react';
import { FaArrowRight, FaRocket, FaCheckCircle } from 'react-icons/fa';
import { PopupModal } from "react-calendly";
const CTA = () => {
  const sectionRef = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        }
      });
    }, { threshold: 0.1 });

    const elements = sectionRef.current?.querySelectorAll('.fade-up, .scale-in');
    elements?.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 max-w-7xl mx-auto px-5 md:px-8">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-purple-900 via-indigo-900 to-blue-900 p-12 text-center scale-in">
        {/* Animated Background */}
        <div className="absolute top-0 -left-20 w-64 h-64 bg-purple-600/30 rounded-full blur-[100px] animate-pulse"></div>
        <div className="absolute bottom-0 -right-20 w-64 h-64 bg-blue-600/30 rounded-full blur-[100px] animate-pulse animation-delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-r from-purple-500/10 to-blue-500/10 blur-3xl"></div>

        <div className="relative z-10 fade-up">
          <FaRocket className="text-5xl text-purple-400 mx-auto mb-4 animate-bounce" />

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold">
            Ready to <span className="gradient-text">build your next project</span>?
          </h2>

          <p className="text-gray-300 text-lg mt-4 max-w-2xl mx-auto">
            Let’s turn your ideas into powerful, scalable software solutions that drive real business growth
          </p>

          {/* Trust Points */}
          <div className="flex flex-wrap gap-3 justify-center mt-6 mb-6">
            <div className="flex items-center gap-2 text-sm">
              <FaCheckCircle className="text-green-400" />
              <span>Free consultation</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <FaCheckCircle className="text-green-400" />
              <span>Custom solutions</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <FaCheckCircle className="text-green-400" />
              <span>End-to-end development</span>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4 justify-center mt-8">

            <button
              onClick={() => setOpen(true)}
              className="border-2 border-white/30 px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-all duration-500 hover:scale-105"
            >
              Book a Free Consultation
            </button>
            <PopupModal
              url="https://calendly.com/YOUR_USERNAME"
              open={open}
              onModalClose={() => setOpen(false)}
              rootElement={document.getElementById("root")}
            />
          </div>

          {/* Bottom Line */}
          <p className="text-sm text-gray-400 mt-6">
            Trusted by startups and businesses for reliable software development
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;